module.exports = __webpack_public_path__ + "img/academy_hacks.0d47f218.png";